export default "__VITE_ASSET__WjbFGmQi__"